<template>
  <div class="user-roles__local-admin">
    <div class="user-roles__local-admin__row">
      <el-checkbox class="r-checkbox" size="mini" v-model="user.local_admin">
        <r-text type="caption">
          {{ $t(`local-admin:checkbox-lable`) }}
        </r-text>
      </el-checkbox>
    </div>
    <div class="user-roles__local-admin__row">
      <transition name="component-fade" mode="out-in">
        <users-list :users="users" v-if="user.local_admin" />
      </transition>
      <transition name="component-fade" mode="out-in">
        <users-list
          :users="users"
          :active-state="true"
          v-if="user.local_admin"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import usersList from "./components/local-admin-users-list";
import isEqual from "lodash.isequal";

export default {
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  components: { usersList },
  data() {
    return {
      isChanged: false
    };
  },
  watch: {
    user: {
      handler: function() {
        this.isChangedInfo();
      },
      deep: true,
      immediate: true
    },
    isChanged: {
      handler: function(val) {
        this.$store.commit("SET_ACTIVE_USER_CHANGES", {
          module: "local_admin",
          value: val
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    user() {
      return this.$store.state.userRoles.activeUser;
    },
    initialUser() {
      return this.$store.state.userRoles.initialUser;
    },
    isAdmin() {
      return this.$store.state.admin;
    }
  },
  methods: {
    isChangedInfo() {
      this.isChanged =
        this.user.local_admin !== this.initialUser.local_admin ||
        !isEqual(this.user.managed_users, this.initialUser.managed_users);
    }
  }
};
</script>

<style lang="scss">
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
.user-roles__local-admin {
  &__row {
    margin-bottom: 8px;
    display: flex;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "local-admin:checkbox-lable": "Права пользовательского администратора"
  },
  "en": {
    "local-admin:checkbox-lable": "User administration rights"
  }
}
</i18n>
